module.exports = __webpack_public_path__ + "assets/img/ic-statistics.c923a7ba.svg";